import ActionColumnComponent from "../../components/ActionColumn/ActionColumn";
import moment from "moment";
// Main columns configuration
export const getAllColumns = (viewModal, updateModal, deleteRecord) => {
  const actionColumn = ActionColumnComponent({
    viewModal,
    updateModal,
    deleteRecord,
  });

  return {
    "Household Members": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Birth Date",
        dataIndex: "Date of Birth",
        key: "Date of Birth",
        render: (record) =>
          record ? moment(record).format("MM/DD/YYYY") : "N/A",
      },
      {
        title: "Social Security Number",
        dataIndex: "Social Security Number",
        key: "socialsecuritynumber",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Blood Type",
        dataIndex: "Blood Type",
        key: "bloodtype",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Medical Condition",
        dataIndex: "Medical Condition",
        key: "medicalcondition",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Allergies",
        dataIndex: "Allergies",
        key: "allergies",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
    "Primary Doctor Contact Information": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "Name",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phoneNumber",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
    "Pediatrician Contact": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "Name",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "Phone Number",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
    "Out-of-State Contact Person Personal and Family Information": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phone number",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Location",
        dataIndex: "Location",
        key: "location",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
    "Pet Information": [
      {
        title: "Pet Name",
        dataIndex: "Pet Name",
        key: "petname",
      },
      {
        title: "Type of Animal",
        dataIndex: "Type of Animal",
        key: "typeofanimal",
      },
      {
        title: "Color",
        dataIndex: "Color",
        key: "color",
      },
      {
        title: "Approx. Age",
        dataIndex: "Approx. Age",
        key: "approxage",
      },
      actionColumn,
    ],
    "School Name": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
      },
      {
        title: "Who's School",
        dataIndex: "Who's School",
        key: "whosschool",
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phone number",
      },
      {
        title: "Street",
        dataIndex: "Street",
        key: "street",
      },
      {
        title: "City",
        dataIndex: "City",
        key: "city",
      },
      {
        title: "State",
        dataIndex: "State",
        key: "state",
      },
      actionColumn,
    ],
    "Workplace/Employer Name": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
      },
      {
        title: "Who's WorkPlace",
        dataIndex: "Who's WorkPlace",
        key: "whosworkplace",
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phonenumber",
      },
      {
        title: "Street",
        dataIndex: "Street",
        key: "street",
      },
      {
        title: "City",
        dataIndex: "City",
        key: "city",
      },
      {
        title: "State",
        dataIndex: "State",
        key: "state",
      },
      actionColumn,
    ],
  };
};

// Usage example in your component:
// const { viewModal, updateModal, deleteRecord } = yourPropsOrContext;
// const AllColumnsData = getAllColumns(viewModal, updateModal, deleteRecord);
